import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations, LANGUAGES } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('appLang') || 'en');

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem('appLang', code);
  }, []);

  const t = translations[lang] || translations.en;
  const currentLang = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, currentLang, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      lang: 'en',
      changeLang: () => {},
      t: translations.en,
      currentLang: LANGUAGES[0],
      languages: LANGUAGES,
    };
  }
  return ctx;
};
